module.exports = __webpack_public_path__ + "img/wwwzk.a7ab97aa.jpg";